import { create } from "zustand";
// import { persist } from "zustand/middleware";

const votesStore = create(
  (set, get) => ({
    votes: [],

    addVote: (id_module, mod, valeur, newpoints) => {
      set((state) => ({
        votes: {
          ...state.votes,
          [id_module]: { module: mod, valeur: valeur, newpoints: newpoints },
        },
      }));
    },
  }),
  {
    name: "votes", // name of the item in the storage (must be unique)
    // storage: createJSONStorage(() => sessionStorage), // (optional) by default, 'localStorage' is used
  }
);

export default votesStore;
